import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About`}</h2>
    <figure className="logo">
  <object data="static/circle-cropped.png" type="image/svg+xml" height="205" width="205"></object>
    </figure>
Holding 3 years of experience, Ayush is a graduate with a Bachelor's in Computer Applications and is currently working as a Product Engineer II at Esri in New Delhi. With expertise in Azure, AWS, and GCP, Ayush has previously worked as a Cloud Automation Engineer at Wipro's Gurgaon Cloud Studio. His skill set spans cloud infrastructure management, CI/CD, automation, and Kubernetes, making him adept at delivering robust and scalable cloud solutions.

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      